import { Optional, Pipe, PipeTransform } from '@angular/core';
import { MeasurementSystem } from '../../auth/models/mmu-user-preferences';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';
import { MmuFormatNumberPipe } from '../format-number/format-number.pipe';
import { MassConversion, MmuMassPipe } from './mass.pipe';


export enum MassUnit {
  KG = 'KG',
  LB = 'LB'
}

const measurementMapping: Record<string, MassUnit> = {
  [MassUnit.KG + '-' + MeasurementSystem.IMPERIAL_UK]: MassUnit.LB,
  [MassUnit.KG + '-' + MeasurementSystem.IMPERIAL_US]: MassUnit.LB
};

/**
 * This pipe is used to format the mass/weight according to the user's preferred format.
 */
@Pipe({
  name: 'formatMass',
  pure: true
})
export class MmuFormatMassPipe implements PipeTransform {
  private massPipe: MmuMassPipe;
  private formatNumberPipe: MmuFormatNumberPipe;
  private readonly measurementSystem: MeasurementSystem;

  constructor(@Optional() private mmuUserService: MmuUserService) {
    if (this.mmuUserService == null) {
      this.measurementSystem = MeasurementSystem.METRIC;
    } else {
      this.measurementSystem = this.mmuUserService.user?.prefs?.measurementSystem ?? MeasurementSystem.METRIC;
    }
    this.massPipe = new MmuMassPipe();
    this.formatNumberPipe = new MmuFormatNumberPipe(this.mmuUserService);
  }

  transform(value: number, inputUnit: MassUnit, digitsInfo?: string): string {
    const outputUnit: MassUnit = this.determineOutputUnit(inputUnit);
    const convertedValue: number = this.convertValue(value, inputUnit, outputUnit);
    const valueString: string = this.formatNumberPipe.transform(convertedValue, digitsInfo);
    return valueString + ' ' + outputUnit.toLowerCase();
  }

  private determineOutputUnit(inputUnit: MassUnit): MassUnit {
    const outputUnit: MassUnit = measurementMapping[inputUnit + '-' + this.measurementSystem];
    return outputUnit ?? inputUnit;
  }

  private convertValue(value: number, inputUnit: MassUnit, outputUnit: MassUnit): number {
    if (inputUnit == outputUnit) {
      return value;
    }
    const conversion = MassConversion[inputUnit + '_' + outputUnit as keyof typeof MassConversion];
    return this.massPipe.transform(value, conversion);
  }
}
